import { Box } from "@mui/joy";
import LinkV2 from "../common/LinkV2";
import useUnifiedNavigate from "../../hooks/useUnifiedNavigate";

export default function CxButton({
  type = "icon",
}: {
  type?: "icon" | "link";
}) {
  const unifiedNavigate = useUnifiedNavigate();

  return (
    <Box
      onClick={() =>
        unifiedNavigate("/support/faq", {
          type: "card",
          gestureEnabled: true,
          animation: "default",
        })
      }
    >
      <LinkV2 text={"고객센터"} />
    </Box>
  );
}
